import React from "react";

import { ReactComponent as LeftArrow } from "../../assets/images/arrow-left.svg";
import { ReactComponent as RightArrow } from "../../assets/images/arrow-right.svg";

import { useIsAr } from "../../Hooks";

import "./style.scss";

const Pagination = ({ setCurrentPage, totalPages = 1, currentPage = 1 }) => {
  const [isAr] = useIsAr();

  const goToPage = (page) => {
    if (page > 0 && page <= totalPages) {
      setCurrentPage(page);
    }
  };

  const getPageNumbers = () => {
    const startPage = Math.floor((currentPage - 1) / 5) * 5 + 1;
    const endPage = Math.min(startPage + 4, totalPages);
    return Array.from(
      { length: endPage - startPage + 1 },
      (_, i) => startPage + i
    );
  };

  return (
    <div className="tablePagination">
      <LeftArrow
        fill={currentPage === 1 ? "#efefef" : "var(--primary-color)"}
        style={{
          cursor: currentPage === 1 ? "not-allowed" : "pointer",
          transform: `rotate(${isAr ? "180deg" : "0deg"})`
        }}
        onClick={() => {
          if (currentPage > 1) goToPage(currentPage - 1);
        }}
      />

      {getPageNumbers().map((page) => (
        <div
          key={page}
          onClick={() => goToPage(page)}
          className={`tablePagination__page ${
            page === currentPage ? "tablePagination__active" : ""
          }`}
        >
          {page}
        </div>
      ))}

      <RightArrow
        fill={currentPage === totalPages ? "#efefef" : "var(--primary-color)"}
        style={{
          cursor: currentPage === totalPages ? "not-allowed" : "pointer",
          transform: `rotate(${isAr ? "180deg" : "0deg"})`
        }}
        onClick={() => {
          if (currentPage < totalPages) setCurrentPage(currentPage + 1);
        }}
      />
    </div>
  );
};

export default Pagination;
